import Card from "../../components/Events/Card";
import ViewList from "../../components/Templates/ViewList";
import useEventsContainer from "../../containers/Events/useEventsContainer";
import { useContent } from "../../content/useContent";
import { Routes } from "../../routes/Routes";

const Events = () => {
  const {
    events,
    pageLoading,
    handleSearch,
    searchValue,
    page,
    handleChangePage,
    rowsPerPage,
    handleClick,

    handleOpenDelete,
    handleDelete,
    handleEdit,
    selected,
    openDeleteDialog,
    setOpenDeleteDialog,
    loading,
  } = useEventsContainer();

  const { events: content } = useContent().pages;

  type IProps = {
    row: any;
  };

  const Row: React.FC<IProps> = ({ row }) => {
    return (
      <Card
        handleClick={handleClick}
        row={row}
        handleOpenDelete={handleOpenDelete}
        handleEdit={handleEdit}
      />
    );
  };

  return (
    <ViewList
      title={content.event}
      multiTitle={content.events}
      selectRef="title"
      pageLoading={pageLoading}
      searchValue={searchValue}
      handleSearch={handleSearch}
      rowsPerPage={rowsPerPage}
      page={page}
      rows={events}
      handleChangePage={handleChangePage}
      Row={Row}
      addPath={Routes.addEvent}
      selected={selected}
      handleDelete={handleDelete}
      openDeleteDialog={openDeleteDialog}
      setOpenDeleteDialog={setOpenDeleteDialog}
      deleteLoading={loading}
    />
  );
};

export default Events;
